import { Component, OnInit } from '@angular/core';

import { ProfileService, Principal } from '../../../../services';

@Component({
    selector: 'qms-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

    public inProduction: boolean;
    public isNavbarCollapsed: boolean;
    public swaggerEnabled: boolean;

    constructor(private principal: Principal,
                private profileService: ProfileService) {
        this.isNavbarCollapsed = true;
    }

    ngOnInit() {
        this.profileService.getProfileInfo().subscribe((profileInfo) => {
            this.inProduction = profileInfo.inProduction;
            this.swaggerEnabled = profileInfo.swaggerEnabled;
        });
    }

    toggleNavbar() {
        this.isNavbarCollapsed = !this.isNavbarCollapsed;
    }

    collapseNavbar() {
        this.isNavbarCollapsed = true;
    }

    isAuthenticated() {
        return this.principal.isAuthenticated();
    }

    getImageUrl() {
        return this.isAuthenticated() ? this.principal.getImageUrl() : null;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/main/header/navbar/navbar.component.ts